// 연차(시간)을 날짜로 환산
export const getAnnualnum = (annualCount: string) => {
  if (annualCount) {
    const toNumber = Number(annualCount) / 8;
    const toString = toNumber.toString();
    return toString;
  }
  return '';
};

/**
 * 수정자 : 홍선영
 * 수정일자 : 2026.07.27
 * 수정내용 : 부여/사용 연차가 falsy(null, '', 0)일 때 무조건 '0'을 반환하던 가드 제거.
 *           연차가 0인 사용자도 사용분만큼 잔여 연차가 음수로 표시되도록 함.
 *           uAnnualnum은 DB에서 nullable이라 연차 미부여자는 null로 내려온다.
 */

// 남은 연차 일수
export const getLeftAnnualDayString = (uAnnual?: string | null, uRannual?: string | null) => ((Number(uAnnual || 0) - Number(uRannual || 0)) / 8).toString();

// 남은 연차 시간
export const getLeftAnnualTimeString = (uAnnual?: string | null, uRannual?: string | null) => (Number(uAnnual || 0) - Number(uRannual || 0)).toString();
/**
 * 수정일자 : 2026.07.28
 * 수정내용 : 근태 신청/결재 화면의 연차 현황 4항목(총/사용/결재대기/신청 가능) 표시용 함수로 교체.
 *           기존 getLeftAnnualDayString/getLeftAnnualTimeString(총 - 사용)은 신청 가능일수가
 *           총 - 사용 - 결재대기로 바뀌면서 호출처가 없어져 제거했다.
 *           uAnnualnum(부여) / uRannualnum(사용) / uPannualnum(결재대기)은 모두 시간 단위
 *           문자열이며 DB에서 nullable 이므로 누락값은 0으로 취급한다. 1일 = 8시간.
 */

// 시간 단위 문자열을 숫자로. null / '' / 해석 불가 값은 0으로 취급한다
const toHours = (value?: string | null) => Number(value || 0) || 0;

// 소수 2자리 반올림. 0.4375 나 0.5100000000000001 같은 값이 화면에 그대로 나가는 것을 막는다
const round2 = (value: number) => Math.round(value * 100) / 100;

// 시간(숫자) → 일수 문자열
export const hoursToDayString = (hours: number) => round2(hours / 8).toString();

// 시간 문자열 → 일수 문자열
export const getAnnualDayString = (hours?: string | null) => hoursToDayString(toHours(hours));

// 시간 문자열 정규화. 표시 형식이 'N일 (M시간)' 이라 시간 값도 화면에 그대로 나간다
export const getAnnualHourString = (hours?: string | null) => round2(toHours(hours)).toString();

// 신청 가능 연차(시간) = 총 - 사용 - 결재대기. 음수 가능
export const getAvailableAnnualHours = (uAnnual?: string | null, uRannual?: string | null, uPannual?: string | null) => round2(toHours(uAnnual) - toHours(uRannual) - toHours(uPannual));
